/** 한국어 이용약관（본문은 이 파일에 추가） */
export const termsTitle = 'BILION PASS 서비스 이용약관';

export const termsBody = `
이용약관
본 이용약관(이하「본 약관」이라 합니다)은 Japan DX주식회사(이하「당사」라 합니다)가 운영하는 BILION PASS 웹사이트(이하「본 사이트」라 합니다)상에서 제공되는 각종 서비스(이하「본 서비스」라 합니다)의 이용조건을 정하는 것입니다. 본 사이트의 이용자(이하「사용자」라 합니다)는 본 약관에 따라 본 서비스를 이용하시기 바랍니다.
제1조 (본 약관의 적용범위)
본 약관은 본 서비스를 이용하는 모든 사용자에게 적용됩니다.
본 약관과 별도로 당사가 본 서비스에 관하여 정하는 제반 규정은 각각 본 약관의 일부를 구성하는 것으로 합니다.
본 약관의 규정과 전항에 따라 당사가 별도로 정하는 제반 규정의 내용이 다른 경우에는 해당 제반 규정의 내용이 우선 적용되는 것으로 합니다.
제2조 (약관의 변경)
당사는 사용자의 동의 없이 본 약관에 관하여 조항의 추가, 변경, 삭제 등을 할 수 있습니다. 그때의 본 서비스 이용조건은 변경 후 본 약관에 따른 것으로 합니다. 또한 변경 후 약관은 당사가 별도로 정하는 경우를 제외하고 본 사이트상에 표시한 시점부터 효력이 발생하는 것으로 하며, 본 약관 변경 후 사용자가 본 서비스를 이용한 경우에는 변경 후 본 약관에 동의한 것으로 간주합니다.
제3조 (이용환경)
본 사이트를 이용하려면 인터넷(웹)에 접속하셔야 합니다. 사용자는 본인의 책임과 비용으로 필요한 기기·소프트웨어, 통신수단 등을 준비하시고, 이를 적절하게 설치·조작하셔야 합니다. 당사는 사용자가 수행하는 이러한 준비, 방법 등에 대해서는 일체 관여하지 않으며 어떠한 책임도 부담하지 않습니다.
제4조 (지적재산권)
본 사이트 및 본 사이트에 게재되는 저작물 등(문장, 사진, 지도, 회화, 도면, 차트, 영화, 음악, 프로그램, 데이터베이스 등의 저작물, 2차적 저작물 및 편집저작물을 포함하되 이에 한정되지 않습니다)에 대한 저작권은 당사 및 기타 권리자에게 귀속됩니다. 이러한 저작물 등에 대해서는 당사 및 기타 권리자의 허가 없이 복제, 공연, 연주, 상영, 공중송신(송신가능화 포함), 구술, 전시, 배포, 양도, 대여, 번역, 변형, 개작 등을 하는 행위는 일체 금지합니다.
본 사이트 및 본 서비스에서 사용되고 있는 상호, 상품명, 서비스명, 로고마크 등은 당사 및 기타 권리자의 등록상표 또는 상표입니다. 이러한 상표에 대해서는 당사 및 기타 권리자의 허가 없이 사용해서는 안 됩니다.
제5조 (본 사이트로의 링크)
본 사이트 사용자는 다음 각 호 중 어느 하나에 해당하거나 그 우려가 있는 방법으로 본 사이트 링크를 설치하는 것을 금지합니다.
① 영리 목적일 경우
② 이미지에 대한 직접 링크일 경우(이미지 표시 관련)
③ 당사에 사회적·경제적 손실이 발생할 것으로 예상되는 경우
④ 독립 프레임 안에 본 사이트를 삽입한 형태로 링크하는 경우
⑤ 제3자가 저작권을 보유하고 게시물 링크를 금지하는 경우
⑥ 기타 본 서비스 운영에 지장을 초래할 우려가 있다고 당사가 판단하는 경우
제6조 (회원가입)
본 사이트는 회원(회원가입 절차를 진행하고 본 서비스를 이용하는 사용자를 말합니다. 이하 같음)으로 등록하지 않고 이용할 수도 있으나, 본 서비스 중 일부 서비스를 이용하려면 회원가입이 필요합니다.
회원가입 시에는 다음 조건을 준수하셔야 합니다. 만약 아래 사항을 위반했거나 진실하고 정확한 데이터가 제공되지 않았다고 당사가 판단한 경우, 당사는 해당 회원의 등록정보를 삭제하고 향후 본 서비스 이용을 거절할 수 있습니다.
① 회원가입 양식에는 회원으로 등록할 사용자 본인이 본인에 관한 진실하고 정확한 데이터를 입력하여 본 사이트를 통해 당사에 전송하셔야 합니다.
② 등록정보는 항상 진실하고 정확한 내용을 유지하기 위해 데이터 내용에 변경이 발생한 경우 적절하게 수정하셔야 합니다. 또한 회원은 본인의 비밀번호를 안전하게 관리해 주시기 바랍니다.
회원가입 시 등록한 등록정보, 그리고 본 서비스 이용상 제공한 정보는 당사가 소유하는 것으로 하며, 당사는 이러한 정보를 본 약관에 정한 외에도 당사가 정하는 개인정보처리방침에 따라 본 서비스와 관련하여 또는 본 서비스 이용 이외의 목적으로 사용할 수 있습니다. 당사는 이러한 정보를 제3자에게 공개하는 경우 해당 회원의 동의를 얻는 것으로 합니다.
당사는 회원으로부터 제공된 개인정보를 바탕으로 본 서비스를 통해 이메일·웹상 공지로 개별 회원에 맞는 정보나 당사 및 업무제휴사의 상품·서비스 안내 등을 할 수 있습니다.
당사는 회원에 대해 당사 또는 업무제휴사의 사업 참고 자료로 설문조사나 인터뷰 등에 협력을 요청할 수 있습니다.
회원이 다음 각 호 중 어느 하나에 해당하는 경우 회원자격을 상실하고 자동으로 탈퇴한 것으로 간주됩니다.
① 당사가 해당 회원의 가입승인을 취소한 경우
② 해당 회원이 본 약관의 어느 한 조항이라도 위반하고 당사가 해당 회원의 제명을 결정한 경우
③ 해당 회원이 소정 절차에 따라 당사에 탈퇴를 신청한 경우
회원에게 연락 또는 통지할 필요가 있다고 당사가 판단한 경우 원칙적으로 등록된 이메일 주소로 이메일을 통해 연락 또는 통지합니다.
제7조 (회원정보의 취급방법)
회원가입 시 등록하신 등록정보 및 기타 당사가 취득한 회원 관련 정보는 당사가 정하는 개인정보처리방침에 따라 취급됩니다.
제8조 (금지사항)
본 사이트 이용 시 다음 행위를 금지합니다.
① 본 사이트를 통해 이용 가능한 정보를 변조·삭제하는 행위
② 본 사이트에 연결된 다른 컴퓨터시스템 또는 네트워크에 대한 불법접근을 시도하는 행위
③ 다른 사용자 또는 제3자 혹은 당사의 저작권, 상표권 등 지적재산권을 침해하는 행위 및 침해할 우려가 있는 행위
④ 다른 사용자 또는 제3자 혹은 당사의 명예 또는 신용을 훼손하는 행위 및 그 우려가 있는 행위
⑤ 다른 사용자 또는 제3자 혹은 당사의 재산, 프라이버시, 초상권, 퍼블리시티권을 침해하는 행위 및 침해할 우려가 있는 행위
⑥ 다른 사용자의 이메일 주소 등을 부정하게 이용하거나 양도·판매하는 행위
⑦ AI 생성 콘텐츠를 당사의 허가 없이 상업적 목적으로 전재·판매하는 행위
⑧ 쿠폰을 부정하게 복제, 변조하거나 제3자에게 재판매하는 행위
⑨ 서버 또는 네트워크의 기능을 파괴하거나 방해하는 행위
⑩ 영업활동 또는 영리 목적 행위 및 그 준비를 목적으로 하는 행위
⑪ 컴퓨터바이러스 등 유해한 프로그램을 사용 또는 제공하는 행위 및 그 우려가 있는 행위
⑫ 다른 사용자 또는 제3자 혹은 당사로 사칭하여 본 서비스를 이용하는 행위
⑬ 다른 사용자 또는 제3자 혹은 당사에게 불이익 또는 손해를 입히는 행위 및 그 우려가 있는 행위
⑭ 공서양속에 위반되는 행위 및 그 우려가 있는 행위
⑮ 범죄행위 또는 범죄와 연계되는 행위 및 그 우려가 있는 행위
⑯ 기타 법률, 명령 또는 조례에 위반되는 행위 및 그 우려가 있는 행위
⑰ 민족적·인종차별적 행위
⑱ 본 사이트의 운영을 방해하는 행위
⑲ 전 각 호에 정한 행위를 조장하는 행위
⑳ 기타 당사가 부적절하다고 판단하는 행위
제9조 (손해배상책임)
사용자가 본 약관에 정한 내용을 위반하여 다른 사용자 및 당사에 손해를 입힌 경우 그 손해(변호사비용 포함)를 배상하는 것으로 합니다. 또한 본 약관 위반으로 인해 제3자와 분쟁이 발생한 경우 사용자는 본인의 책임과 비용으로 이를 처리·해결하고 당사에 손해·폐를 끼치지 않는 것으로 합니다.
제10조 (면책사항)
당사는 본 서비스를 제공함에 있어 다음 사항에 대해 일체 보증하지 않습니다.
① 사용자의 요구를 완전히 충족시키는 것
② 게재된 정보가 속보성·정확성·적법성·유용성·완전성을 갖추는 것
③ 기능의 중단, 시스템의 오류·버그·결함 등이 발생하지 않는 것
④ 결함을 수정하는 것
⑤ 컴퓨터바이러스 기타 유해물이 없는 것
⑥ 본 서비스 이용 또는 이용할 수 없었던 것으로 인해 사용자가 손해를 입는 것
본 서비스에서는 현재 관광 및 여행에 관한 정보와 기능을 제공하고 있으나, 서비스 향상을 위해 사전 통지 없이 추가·변경·중단·삭제 등을 할 수 있습니다.
당사는 다음 경우에 사전 통지 없이 본 사이트 운영을 중단하거나 정지할 수 있습니다.
① 정보·기능 또는 시스템 변경을 정기적으로 또는 긴급하게 실시하는 경우
② 시스템 또는 설비 점검을 정기적으로 또는 긴급하게 실시하는 경우
③ 천재지변, 지진, 정전 등으로 인해 본 서비스 제공을 유지할 수 없게 된 경우
④ 기타 예측불가능한 사태로 인해 정지·종료할 필요가 생긴 경우
당사는 이유 여하를 불문하고 본 서비스를 이용함으로써 발생한 어떠한 손해, 및 본 서비스의 정보·기능 변경이나 운영 중단·정지로 인해 발생한 어떠한 손해에 대해서도 책임을 부담하지 않습니다.
본 사이트로부터 또는 본 사이트로 링크를 설치한 당사 이외의 제3자 웹사이트(이하「링크사이트」라 합니다)의 내용은 각 링크사이트 운영주의 책임으로 관리되는 것이며, 링크사이트 이용 시에는 각 링크사이트의 이용조건 및 저작권 취급 등 규정을 준수하시기 바랍니다. 당사는 링크사이트 내용에 대해, 또한 링크사이트를 이용함으로써 발생한 어떠한 손해에 대해서도 책임을 부담하지 않습니다.
당사는 천재지변 등 불가항력 또는 영업상 부득이한 사유 혹은 영업전략상 판단에 따라 본 서비스 전부 또는 일부를 종료할 수 있습니다.
제11조 (양도금지)
사용자는 본 서비스 제공을 받을 권리를 제3자에게 양도, 매매, 명의변경, 질권설정 기타 담보제공 등 행위를 해서는 안 됩니다. 회원가입은 신체전속성이 있는 것으로 합니다.
제12조 (문의)
본 서비스에 관한 문의는 당사 소정 방법에 따른 것으로 합니다.
사용자로부터의 의견, 문의 등
사용자로부터의 의견, 문의에 대한 당사의 이메일 등 회신에 대해서는 사전 서면으로 당사의 동의를 얻지 않고 복제, 공중송신, 전송, 전재 등을 하거나 제3자에게 공개하는 것을 금지합니다.
제13조 (준거법·재판관할)
본 약관 해석 시에는 일본법을 준거법으로 합니다.
본 서비스에 관해 분쟁이 발생한 경우 당사 본사 소재지를 관할하는 법원을 전속 합의관할법원으로 합니다.
이상
당사가 본 서비스에 관해 정하는 제반 규정
AI 여행플랜 작성 서비스
본 서비스에서는 인공지능(AI)을 이용하여 사용자의 요청에 따른 여행플랜을 생성합니다.
AI가 생성하는 플랜(경로, 소요시간, 시설정보 등)은 반드시 정확성, 최신성 또는 완전성을 보장하는 것은 아닙니다. 실제 여행 시에는 대중교통 운행상황이나 시설 영업시간을 사용자 본인이 사전에 확인하는 것으로 합니다.
기타 서비스
본 서비스에 적용되는 조건에 대해서는 본 사이트로부터의 이동처에 게시된 약관을 확인하시기 바랍니다.
이상
`;
